import type {
  AcquiredPropertiesActions,
  AcquiredPropertiesState,
} from "./types";

const INITIAL_STATE: AcquiredPropertiesState = {
  loading: false,
  refreshing: false,
  error: false,
  data: {
    page: {
      card: "",
      pagebanner: "",
      blurb: "",
      bannerCTA: "",
      benefitsHeader: "",
      benefits: [],
      services: [],
      stepsHeader: "",
      steps: [],
      stepsHeader1: "",
      steps1: [],
      promos: [],
      items: [],
    },
    list: [],
  },
};

export default (
  state: AcquiredPropertiesState = INITIAL_STATE,
  action: AcquiredPropertiesActions
): AcquiredPropertiesState => {
  switch (action.type) {
    case "REQUEST_ACQUIRED_PROPERTIES_DATA": {
      return {
        ...state,
        refreshing: false,
        error: false,
        loading: true,
      };
    }
    case "REQUEST_ACQUIRED_PROPERTIES_DATA_SUCCESS": {
      return {
        refreshing: false,
        loading: false,
        error: false,
        data: action.payload,
      };
    }
    case "REQUEST_ACQUIRED_PROPERTIES_DATA_FAILED": {
      return {
        ...state,
        refreshing: false,
        loading: false,
        error: true,
      };
    }
    default:
      return state;
  }
};
